"use strict";
document.addEventListener("DOMContentLoaded", function() {
    var menu = document.querySelector(".page__menu");
    var openMenuBtn = document.querySelector(".hero__open-menu");
    var closeMenuBtn = document.querySelector(".menu__close-menu");
    var scrollToTop = function() {
        document.documentElement.scrollIntoView();
    };
    var openMenu = function() {
        menu === null || menu === void 0 ? void 0 : menu.classList.add("page__menu--active");
    };
    var closeMenu = function() {
        menu === null || menu === void 0 ? void 0 : menu.classList.remove("page__menu--active");
    };
    openMenuBtn.addEventListener("click", function() {
        openMenu();
        scrollToTop();
    });
    closeMenuBtn.addEventListener("click", function() {
        closeMenu();
        scrollToTop();
    });
    menu.addEventListener("click", function(e) {
        if (e.target.closest("a")) closeMenu();
    });
    window.addEventListener("resize", function() {
        if (window.innerWidth > 767) closeMenu();
    });
});

//# sourceMappingURL=index.00ddd74d.js.map
